export enum URLReflection {
  ON_APPLY = 'apply',
  ON_CHANGE = 'change'
}
